import { Box, Image, Stack, StackProps, Text, TextProps, useColorModeValue } from '@chakra-ui/react';
import { getAsset } from '@pelicargo/tenants';
import { Show } from '@pelicargo/ui';
import { ReactNode } from 'react';

import { CopyableText } from './CopyableText';

type LabeledTextProps = StackProps & {
  label?: ReactNode | string | null;
  value?: string | ReactNode | null;
  isHighlighted?: boolean;
  textProps?: TextProps;
  isCopyable?: boolean;
  isSparkling?: boolean;
  isHorizontal?: boolean;
};

export const LabeledText = ({
  label,
  value = '-',
  isHighlighted,
  textProps,
  isCopyable = false,
  isSparkling = false,
  isHorizontal = false,
  ...rest
}: LabeledTextProps) => {
  const highlightedBgColor = useColorModeValue('orange.200', 'orange.800');
  const backgroundColor = isHighlighted ? highlightedBgColor : 'transparent';

  const useCopyableText = isCopyable && typeof value === 'string';

  return (
    <Stack direction={isHorizontal ? 'row' : 'column'} spacing={0} backgroundColor={backgroundColor} {...rest}>
      <Box fontSize="xs" fontWeight="400" w={isHorizontal ? 32 : undefined}>
        {label}
      </Box>
      <Stack direction="row" spacing="1" flex={isHorizontal ? 1 : undefined}>
        <Show if={isSparkling}>
          <Image src={getAsset('sparkle.svg')} />
        </Show>
        <Show if={useCopyableText}>
          <CopyableText fontSize="sm" fontWeight="600" value={value as string} {...textProps} />
        </Show>
        <Show if={!useCopyableText}>
          <Box fontSize="sm" fontWeight="600" whiteSpace="pre-wrap" {...textProps}>
            {value}
          </Box>
        </Show>
      </Stack>
    </Stack>
  );
};

type LabelProps = TextProps & { label: string };

export const Label = ({ label, ...rest }: LabelProps) => (
  <Text fontSize="xs" fontWeight="400" {...rest}>
    {label}
  </Text>
);
